/* eslint-disable @next/next/no-img-element */
"use client";
import Link from "next/link";

interface IPostsData {
  title?: string;
  imgUrl?: string;
  href?: string;
  desc?: string;
  className?: string;
  SlideWidth?: string;
  style?: any;
}

export default function SingleFeaturePost(props: IPostsData) {
  const { title = "", imgUrl = "", className = "", href = "" } = props;
  return (
    <Link
      href={href}
      className="relative flex h-[30rem] max-md:h-[22rem] rounded-2xl text-left overflow-hidden"
    >
      <img
        loading="lazy"
        className="h-full w-full object-cover block"
        src={imgUrl}
        alt="Trulli"
      />
      <div
        className="text-left absolute bottom-0 text-primary-800 
          pt-12 pb-4 px-4 left-0 right-0 bg-gradient-to-b xl:text-[2.1rem] 
          lg:text-[1.7rem] text-[1.35rem]   font-medium  from-transparent via-gray-100
         to-white/[0.9]"
      >
        {title}
      </div>
    </Link>
  );
}
